import React from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { AlertCircle } from 'lucide-react';
interface ForceCloseStoreModalProps {
  isOpen: boolean;
  onClose: () => void;
  storeName: string;
  onConfirm: () => void;
}
export function ForceCloseStoreModal({
  isOpen,
  onClose,
  storeName,
  onConfirm
}: ForceCloseStoreModalProps) {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };
  return <Modal isOpen={isOpen} onClose={onClose} title="Force Close Store?" size="sm" footer={<>
          <Button variant="outline" onClick={onClose} data-id="element-168">
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirm} data-id="element-169">
            Force Close Store
          </Button>
        </>} data-id="element-167">
      <div className="space-y-4" data-id="element-170">
        <div className="flex items-start space-x-3" data-id="element-171">
          <AlertCircle className="h-5 w-5 text-red-600 mt-0.5 flex-shrink-0" data-id="element-172" />
          <div className="text-sm text-gray-700" data-id="element-173">
            <p className="mb-2" data-id="element-174">
              Are you sure you want to force close{' '}
              <span className="font-semibold" data-id="element-175">"{storeName}"</span>?
            </p>
            <p className="text-gray-600" data-id="element-176">
              This will immediately close the store regardless of the scheduled
              close date. Customers will no longer be able to place orders.
            </p>
          </div>
        </div>

        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3" data-id="element-177">
          <p className="text-xs text-yellow-800" data-id="element-178">
            <span className="font-medium" data-id="element-179">Note:</span> You can reopen the store
            later from the Fulfillment page if needed.
          </p>
        </div>
      </div>
    </Modal>;
}